import { useNavigate, useParams } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import Home from "../../pages/home/pg-home";
import Footer from "../../components/footer-tab/fixedfooter";
import HeaderHome from "../../components/header-tab/fixed-header-home";
import ProductList, { PromoProductList } from "../../pages/home/pg-product-list";
import HeaderCommon from "../../components/header-tab/fixed-common-header";
import Startup from "../../pages/home/pg-startup";
import Product from "../../pages/home/pg-product";
import FilterOutletsProducts from "../../pages/home/pg-filter-outlets-products";
import CategoryWiseMerchant from "../../pages/home/pg-merchants-to-mobile-app-category.js";
import MasterCategory from "../../pages/home/pg-master-category";
import Landing from "../../pages/home/pg-landing";
import Settings from "../../pages/home/pg-settings.js";
import Configure from "../../pages/home/pg-configure.js";
import TypeLanding from "../../pages/home/pg-type-landing.js";

export function RTStartup(props) {
  const navigate = useNavigate();
  const params = useParams();
  return (
    <>
      <ToastContainer />
      <Startup navigate={navigate} params={params} />
    </>
  );
}

export function RTSettings(props) {
  const navigate = useNavigate();
  const params = useParams();
  return (
    <>
      <ToastContainer />
      <HeaderCommon navigate={navigate} params={params} />
      <Settings navigate={navigate} params={params} />
    </>
  );
}

export function RTConfigure(props) {
  const navigate = useNavigate();
  const params = useParams();
  return (
    <>
      <ToastContainer />
      <Configure navigate={navigate} params={params} />
    </>
  );
}

export function RTLand(props) {
  const navigate = useNavigate();
  const params = useParams();
  return (
    <>
      <ToastContainer />
      <Landing navigate={navigate} params={params} />
    </>
  );
}

export function RTTypeLand(props) {
  const navigate = useNavigate();
  const params = useParams();
  return (
    <>
      <ToastContainer />
      <TypeLanding navigate={navigate} params={params} />
    </>
  );
}

export function RTHome(props) {
  const navigate = useNavigate();
  const params = useParams();
  return (
    <>
      <ToastContainer />
      <HeaderHome navigate={navigate} params={params} />
      <Home navigate={navigate} params={params} />
      <Footer navigate={navigate} params={params} />
    </>
  );
}

export function RTPromoProductList(props) {
  const navigate = useNavigate();
  const params = useParams();
  return (
    <>
      <ToastContainer />
      <HeaderCommon navigate={navigate} params={params} />
      <PromoProductList navigate={navigate} params={params} />
      <Footer navigate={navigate} params={params} />
    </>
  );
}

export function RTProductList(props) {
  const navigate = useNavigate();
  const params = useParams();
  return (
    <>
      <ToastContainer />
      <HeaderCommon navigate={navigate} params={params} />
      <ProductList navigate={navigate} params={params} />
      <Footer navigate={navigate} params={params} />
    </>
  );
}

export function RTProduct(props) {
  const navigate = useNavigate();
  const params = useParams();
  return (
    <>
      <ToastContainer />
      <HeaderCommon navigate={navigate} params={params} />
      <Product navigate={navigate} params={params} />
      <Footer navigate={navigate} params={params} />
    </>
  );
}

export function RTOutletsProduct(props) {
  const navigate = useNavigate();
  const params = useParams();
  return (
    <>
      <ToastContainer />
      <HeaderCommon navigate={navigate} params={params} />
      <FilterOutletsProducts navigate={navigate} params={params} />
      <Footer navigate={navigate} params={params} />
    </>
  );
}

export function RTMasterCategory(props) {
  const navigate = useNavigate();
  const params = useParams();
  return (
    <>
      <ToastContainer />
      <HeaderCommon navigate={navigate} params={params} />
      <MasterCategory navigate={navigate} params={params} />
      <Footer navigate={navigate} params={params} />
    </>
  );
}

export function RTCategoryWiseMerchant(props) {
  const navigate = useNavigate();
  const params = useParams();
  return (
    <>
      <ToastContainer />
      <HeaderCommon navigate={navigate} params={params} />
      <CategoryWiseMerchant navigate={navigate} params={params} />
      <Footer navigate={navigate} params={params} />
    </>
  );
}
